import HexToRgba from "./HexToRgba";

const COLOR = {
    indigo: "#004766",
    skyBlue: "#B3E4FF",
    white: "#FFFFFF",
    back_indigo: HexToRgba("#004766", 0.5)
}

export default COLOR;